import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a476fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "praise-modal__delivery__method__icon" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "praise-modal__delivery__method__content" }
const _hoisted_4 = ["for"]

import RadioButton from 'primevue/radiobutton'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import MicrosoftTeamLogo from '@/assets/img/Icons/microsoft-teams.svg'
import SlackLogo from '@/assets/img/Icons/slack.svg'
import {
    SEND_METHOD_SLACK,
    SEND_METHOD_TEAMS,
    SendMethod,
} from '@/entities/frontlineManagerDash'

type Props = {
    method: SendMethod
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PraiseModalDeliveryMethod',
  props: /*#__PURE__*/_mergeModels({
    method: {}
  }, {
    "selectedSendMethod": {},
    "selectedSendMethodModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['change'], ["update:selectedSendMethod"]),
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const selectedSendMethod = _useModel(__props, 'selectedSendMethod')

const getDeliveryMethodClass = (key: string) => {
    return [
        'praise-modal__delivery__method',
        selectedSendMethod.value === key
            ? 'praise-modal__delivery__method--selected'
            : '',
    ]
}

const getDeliveryMethodLogo = (key: string) => {
    if (key === SEND_METHOD_SLACK) {
        return SlackLogo
    }

    if (key === SEND_METHOD_TEAMS) {
        return MicrosoftTeamLogo
    }

    return null
}

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(getDeliveryMethodClass(_ctx.method.key))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.method.svgIcon)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: getDeliveryMethodLogo(_ctx.method.key),
            alt: "method icon"
          }, null, 8, _hoisted_2))
        : (_ctx.method.faIcon)
          ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
              key: 1,
              icon: _ctx.method.faIcon
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives((_openBlock(), _createElementBlock("label", {
        for: _ctx.method.key,
        class: "praise-modal__delivery__method__label"
      }, [
        _createTextVNode(_toDisplayString(_ctx.method.label), 1)
      ], 8, _hoisted_4)), [
        [
          _directive_tooltip,
          _ctx.method.toolTipMsg,
          void 0,
          { top: true }
        ]
      ]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(_unref(RadioButton), {
      modelValue: selectedSendMethod.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((selectedSendMethod).value = $event)),
        _cache[1] || (_cache[1] = 
                (value) => _ctx.$emit('change', value, _ctx.method.label)
            )
      ],
      class: "praise-modal__delivery__method__radio-button",
      value: _ctx.method.key,
      "input-id": _ctx.method.key,
      name: "method"
    }, null, 8, ["modelValue", "value", "input-id"])
  ], 2))
}
}

})